import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=1cbfcb42&scoped=true&"
import script from "./ChatIcon.ts?vue&type=script&lang=ts&"
export * from "./ChatIcon.ts?vue&type=script&lang=ts&"
import style0 from "./ChatIcon.vue?vue&type=style&index=0&id=1cbfcb42&lang=vue-scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbfcb42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbfcb42')) {
      api.createRecord('1cbfcb42', component.options)
    } else {
      api.reload('1cbfcb42', component.options)
    }
    module.hot.accept("./ChatIcon.vue?vue&type=template&id=1cbfcb42&scoped=true&", function () {
      api.rerender('1cbfcb42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/ChatBox/Components/ChatIcon.vue"
export default component.exports